export default {
  'name': '',
  'photo': '',
  'startDate': '',
  'endDate': '',
  'air_temp': '',
  'complexity': {
    'name': '',
    'description': '',
    'complexity': '',
  },
  'complexitiesCount': 0,
  'discount': 0,
  'discountMembersCount': 0,
  'discountPromo': 0,
  'price': 0,
  'priceFormatted': 0,
  'discountPriceFormatted': 0,
  'discountPrice': 0,
  'water_temp': '',
  'currency': ''
}
